import store from '../store';
import {
  SET_AVAILABILITY,
  SET_PLATFORM,
  SET_APP_VERSION,
  SET_DEVICE_NAME,
  SET_DEVICE_MODEL_NAME,
  SET_DEVICE_MODEL_ID,
  SET_OS_VERSION,
} from '../store/modules/hardware';

export const EVENTS = {
  WEB_READY: 'hardware.webReady',
  APP_READY: 'hardware.appReady',
  START_SCAN_CODE: 'hardware.startScanCode',
  PROCESSING_CODE: 'hardware.processingCode',
  PROCESSING_CODE_ERROR: 'hardware.processingCodeError',
  STOP_SCAN_CODE: 'hardware.stopScanCode',
  CAMERA_FAILURE: 'hardware.cameraFailure',
  QRCODE_SUCCESS: 'hardware.onQRCodeReadSuccess',
  QRCODE_ERROR: 'hardware.onQRCodeReadError',
  ON_SCANNER_KEY: 'hardware.onScannerSessionKey',
  GET_SCANNER_KEY: 'hardware.getScannerSessionKey',
  START_ARM_DETECTION: 'hardware.startArmDetection',
  STOP_ARM_DETECTION: 'hardware.stopArmDetection',
  START_BT_SCAN: 'hardware.startBTScan',
  STOP_BT_SCAN: 'hardware.stopBTScan',
  SHOW_BT_SETTINGS: 'hardware.showBTSettings',
  BT_DEVICE_CHANGED: 'hardware.onBTDeviceChanged',
  BT_ERROR: 'hardware.onBluetoothError',
  BT_READY: 'hardware.onBluetoothReady',
  BT_DATA: 'hardware.onBluetoothData',
  BT_DATA_ERROR: 'hardware.onBluetoothDataError',
  SET_AVAILABILITY: 'hardware.setAvailability',
  CHECK_ALL_AVAILABILITY: 'hardware.checkAllAvailability',
  WEB_URL: 'hardware.webUrl',
  LOG: 'hardware.log',
  PLATFORM: 'hardware.platform',
  SOCIAL_SIGN_IN_DONE: 'hardware.socialSignInDone',
  SOCIAL_SIGN_IN_FAILED: 'hardware.socialSignInFailed',
  AUTH_LOADED: 'hardware.authLoaded',
  CLEAR_AUTH: 'hardware.clearAuth',
  // mobile scan
  SET_OVERLAY_STYLES: 'hardware.setOverlayStyles',
  START_SPIRIT_LEVEL_DETECTION: 'hardware.startSpiritLevelDetection',
  STOP_SPIRIT_LEVEL_DETECTION: 'hardware.stopSpiritLevelDetection',
  SPIRIT_LEVEL: 'hardware.spiritLevel',
  LAUNCH_MOBILE_SCAN: 'hardware.launchMobileScan',
  START_MOBILE_SCAN_BACKOFF_COUNTDOWN: 'hardware.startMobileScanBackoffCountdown',
  START_MOBILE_SCAN_RECORDING: 'hardware.startMobileScanRecording',
  STOP_MOBILE_SCAN_RECORDING: 'hardware.stopMobileScanRecording',
  SHOW_VIDEO: 'hardware.showVideo',
  HIDE_VIDEO: 'hardware.hideVideo',
  START_MOBILE_SCAN_UPLOADING: 'hardware.startMobileScanUploading',
  CLOSE_MOBILE_SCAN: 'hardware.closeMobileScan',
  MOBILE_SCAN_SCAN_ERROR: 'hardware.mobileScanScanError',
  MOBILE_SCAN_PREVIEW_VIDEO_SOURCE: 'hardware.mobileScanPreviewVideoSource',
  MOBILE_SCAN_UPLOAD_PROGRESS: 'hardware.mobileScanUploadProgress',
  MOBILE_SCAN_UPLOAD_COMPLETE: 'hardware.mobileScanUploadComplete',
  MOBILE_SCAN_UPLOAD_ERROR: 'hardware.mobileScanUploadError',
  DEEP_LINK: 'hardware.deepLink',
  OPEN_LINK_IN_BROWSER: 'hardware.openLinkInBrowser',
  MOBILE_REQUEST_PAYMENT: 'hardware.mobileRequestPayment',
  MOBILE_PAYMENT_SUCCEED: 'hardware.mobilePaymentSucceed',
  MOBILE_PAYMENT_CANCELED: 'hardware.mobilePaymentCanceled',
  MOBILE_PAYMENT_FAILED: 'hardware.mobilePaymentFailed',
};

const setAvailability = (name, isAvailable) => {
  store.commit(`hardware/${SET_AVAILABILITY}`, { name, isAvailable });
};

const checkAllAvailability = () => {
  setAvailability('bluetooth', typeof navigator.bluetooth !== 'undefined');
  setAvailability('camera', false);
};

const setPlatform = info => {
  const { platform, version, osVersion, modelName, modelId, deviceName, productName } = info;
  console.log(version, osVersion, modelName, modelId, deviceName, productName);
  store.commit(`hardware/${SET_PLATFORM}`, platform);
  store.commit(`hardware/${SET_OS_VERSION}`, osVersion);

  if (version) {
    store.commit(`hardware/${SET_APP_VERSION}`, version);
  }
  if (deviceName) {
    store.commit(`hardware/${SET_DEVICE_NAME}`, deviceName);
  }
  if (modelName) {
    store.commit(`hardware/${SET_DEVICE_MODEL_NAME}`, modelName);
  }
  if (modelId) {
    store.commit(`hardware/${SET_DEVICE_MODEL_ID}`, modelId);
  } else if (productName) {
    // ANDROID
    store.commit(`hardware/${SET_DEVICE_MODEL_ID}`, productName);
  }
};

const hardware = {
  setup(namespace, root) {
    const { handlers } = this;
    Object.keys(handlers).forEach(handlerName => {
      root.on(`${namespace}.${handlerName}`, this.handlers[handlerName]);
    });
  },
  handlers: {
    setAvailability,
    checkAllAvailability,
    onBluetoothReady: () => setAvailability('bluetooth', true),
    onBluetoothError: () => setAvailability('bluetooth', false),
    onBluetoothDataError: message => console.log('[ERROR] [BT] Data error:', message),
    log: message => console.log(message),
    platform: info => setPlatform(info),
  },
};

export default hardware;
